/**
 * Parent class of all shape class
 */
function TextShape(draw, text) {
    this.draw = draw;
    this.text = text.clone();

    // preserve original text object
    this.originalText = text;
    this.hideOriginalText();

    TextShape.registeredFonts = [];
}

TextShape.prototype = {
    showOriginaText: function() {
        this.originalText.style('visibility', "visible");
    },

    hideOriginalText: function() {
        this.originalText.style('visibility', "hidden");
    },

    returnToOriginalText: function() {
        this.text.remove(); // remove text
        this.showOriginaText();
    },

    changeColor: function(color) {
        this.text.font("fill", color);
        this.originalText.font("fill", color);
    },

    changeStrokeColor: function(color) {
        this.text.font('stroke', color);
        this.originalText.font('stroke', color);
    },

    changeStrokeWidth: function(width) {
        this.text.font('stroke-width', width);
        this.text.data('stroke-width', width);

        this.originalText.font('stroke-width', width);
        this.originalText.data('stroke-width', width);
    },

    removeOutline: function() {
        this.text.font({
            'stroke': "transparent",
            'stroke-width': 0
        });

        this.originalText.font({
            'stroke': "transparent",
            'stroke-width': 0
        });
    },

    changeText: function(text) {
        this.text.text(text);
        this.originalText.text(text);
    },

    changeFontSize: function(size) {
        this.text.font('size', size);
        this.originalText.font('size', size);
    },

    changeFontFamily: function(family) {
        this.text.font('family', family);
        this.originalText.font('family', family);
    },

    moveToCenter: function(xAdjustment, yAdjustment) {
        xAdjustment = xAdjustment || 0;
        yAdjustment = yAdjustment || 0;

        var bbox = this.text.bbox();
        var frame_width = this.draw.attr("width");
        var frame_height = this.draw.attr("height");

        var center_x = ((frame_width/2) - (bbox.width/2)) + xAdjustment;
        var center_y = ((frame_height/2) - (bbox.height/2)) + yAdjustment;

        this.text.move(center_x, center_y);
    }
};

TextShape.isFontRegistered = function(font_name) {
    return TextShape.registeredFonts.indexOf(font_name) !== -1;
};

TextShape.registerFont = function(draw, font_name, font_path, callback) {
    // create style tag inside of svg element if not exist
    var styleSVGTag = draw.node.querySelector("style");
    if (styleSVGTag === null) {
        styleSVGTag = document.createElement("style");
        draw.node.appendChild(styleSVGTag);
    }

    if (!TextShape.isFontRegistered(font_name)) {
        TextShape.convertFileToBase64(font_path, function(font_base_64) {
            var cssContent = '@font-face {font-family: "'+font_name+'";src: url("'+font_base_64+'");}';
            styleSVGTag.appendChild(document.createTextNode(cssContent));

            TextShape.registeredFonts.push(font_name);

            callback();
        });
    }
};

TextShape.convertFileToBase64 = function(file_path, callback) {
    var xhr = new XMLHttpRequest();
        xhr.open("GET", file_path, true);
        xhr.responseType = "blob";
        xhr.onload = function (e) {
            var reader = new FileReader();
            var file = this.response;
            reader.readAsDataURL(file);

            reader.onload = function(event) {
               var res = event.target.result;
               callback(res);
            };
        };
        xhr.send();
};

TextShape.exportToPNG = function(draw, callback) {
    var canvas = document.createElement("canvas");
    var width = parseInt(draw.node.getAttribute("width"));
    var height = parseInt(draw.node.getAttribute("height"));

    canvas.width = width;
    canvas.height = height;

    var ctx = canvas.getContext("2d");
    var svgString = draw.svg();

    var DOMURL = self.URL || self.webkitURL || self;
    var img = new Image();
    var svg = new Blob([svgString], {type: "image/svg+xml;charset=utf-8"});
    var url = DOMURL.createObjectURL(svg);

    img.src = url;

    img.onload = function() {
        ctx.drawImage(img, 0, 0);
        var png = canvas.toDataURL("image/png");
        callback(png);
    };
};